import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

const tokenFeatures = [
  {
    icon: 'ri-coins-line',
    color: 'text-orange-400',
    bg: 'bg-orange-400/10',
    title: 'Gana PokTaToken',
    description: 'Por cada reserva que hagas en la plataforma, recibes PokTaToken directamente en tu wallet. Cuantas mas reservas, mas tokens.'
  },
  {
    icon: 'ri-gift-line',
    color: 'text-purple-400',
    bg: 'bg-purple-400/10',
    title: 'Referidos con Recompensas',
    description: 'Invita a tus amigos y gana PokTaToken por cada nuevo usuario que realice su primera reserva. Sin limites.'
  },
  {
    icon: 'ri-shield-check-line',
    color: 'text-emerald-400',
    bg: 'bg-emerald-400/10',
    title: 'Seguridad Blockchain',
    description: 'PokTaToken opera sobre blockchain. Transacciones transparentes, verificables y seguras. Tu controlas tus tokens.'
  },
  {
    icon: 'ri-exchange-dollar-line',
    color: 'text-yellow-400',
    bg: 'bg-yellow-400/10',
    title: 'Cashback en PokTaToken',
    description: 'Recibe hasta un 5% de cashback en PokTaToken por cada reserva que realices. Tus tokens, tus reglas.'
  },
  {
    icon: 'ri-vip-crown-line',
    color: 'text-amber-400',
    bg: 'bg-amber-400/10',
    title: 'Acceso VIP',
    description: 'Canjea tus PokTaToken por acceso VIP a canchas exclusivas, eventos especiales y torneos privados.'
  },
  {
    icon: 'ri-wallet-3-line',
    color: 'text-blue-400',
    bg: 'bg-blue-400/10',
    title: 'Wallet Integrada',
    description: 'Conecta tu wallet favorita (MetaMask, Trust Wallet, etc.) directamente desde la plataforma. Sin complicaciones.'
  }
];

const faqs = [
  {
    question: 'Que es PokTaToken?',
    answer: 'PokTaToken es la criptomoneda oficial de la plataforma PokTaPok. Es un token de utilidad que recompensa a los usuarios por usar la plataforma y puede canjearse por beneficios exclusivos.'
  },
  {
    question: 'Como gano PokTaToken?',
    answer: 'Ganas PokTaToken de tres formas: 1) Por cada reserva que hagas, 2) Por referir amigos que completen su primera reserva, 3) Por cashback del 5% sobre cada transaccion. Tambien puedes comprarlos directamente.'
  },
  {
    question: 'En que puedo usar mis PokTaToken?',
    answer: 'Puedes usar tus PokTaToken para obtener descuentos en reservas, acceder a canchas VIP, participar en eventos exclusivos, obtener reservas gratuitas y acceder a funciones premium de la plataforma.'
  },
  {
    question: 'Puedo usar pesos mexicanos todavia?',
    answer: 'Por supuesto. Seguimos aceptando pagos tradicionales con tarjeta de credito, debito y transferencia bancaria. PokTaToken es una opcion adicional de pago y recompensa, no un reemplazo.'
  },
  {
    question: 'Es seguro usar PokTaToken?',
    answer: 'Absolutamente. PokTaToken opera sobre blockchain con contratos inteligentes auditados. Tus tokens se almacenan en tu propia wallet y tu tienes el control total. La plataforma nunca retiene tus fondos.'
  },
  {
    question: 'Necesito saber de criptomonedas para usar PokTaToken?',
    answer: 'No necesitas ser experto. La plataforma te guia paso a paso para conectar tu wallet y usar PokTaToken. Si prefieres, puedes seguir usando pesos mexicanos sin problemas.'
  }
];

export default function PokTaToken() {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero */}
      <section className="relative bg-gradient-to-br from-green-900 to-green-800 text-white py-20 md:py-28">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Abstract%20golden%20cryptocurrency%20coin%20with%20glowing%20green%20network%20connections%20on%20dark%20background%2C%20blockchain%20technology%20pattern%20with%20digital%20nodes%2C%20futuristic%20finance%20concept%20with%20subtle%20soccer%20elements%2C%20dark%20minimal%20geometric%20design%20with%20gold%20and%20green%20accents&width=1600&height=900&seq=poktatoken-bg&orientation=landscape')] bg-cover bg-center"></div>
        </div>
        <div className="container mx-auto px-4 relative">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 mb-6">
              <i className="ri-coins-line text-yellow-300"></i>
              <span className="text-sm font-medium text-yellow-100">Token Oficial de PokTaPok</span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              PokTaToken
            </h1>
            <p className="text-xl md:text-2xl text-green-100 mb-10 leading-relaxed">
              La criptomoneda que revoluciona las reservas deportivas en Mexico. 
              Gana, canjea y disfruta beneficios exclusivos.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                className="bg-white text-green-800 hover:bg-gray-100"
                onClick={() => navigate('/anuncio')}
              >
                <i className="ri-coins-line mr-2"></i>
                Reservar con PokTaToken
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-white text-white hover:bg-white hover:text-green-800"
                onClick={() => navigate('/roadmap')}
              >
                <i className="ri-map-line mr-2"></i>
                Ver Roadmap
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Token Stats */}
      <section className="py-12 bg-green-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-green-700">1M+</p>
              <p className="text-gray-600 mt-1">Tokens Emitidos</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-green-700">5,000+</p>
              <p className="text-gray-600 mt-1">Usuarios Activos</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-green-700">50K+</p>
              <p className="text-gray-600 mt-1">Transacciones</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-green-700">$2.5</p>
              <p className="text-gray-600 mt-1">Valor Estimado</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Por que usar PokTaToken?
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              El token que te recompensa por jugar. Gana, canjea y disfruta 
              beneficios que ninguna otra plataforma te ofrece.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {tokenFeatures.map((feature, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300"
              >
                <div className={`w-14 h-14 rounded-lg ${feature.bg} flex items-center justify-center mb-4`}>
                  <i className={`${feature.icon} text-2xl ${feature.color}`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Como funciona */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Como funciona PokTaToken?
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Cuatro pasos simples para empezar a ganar y usar PokTaToken
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-green-600 flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-add-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">1. Registrate</h3>
              <p className="text-gray-600 text-sm">Crea tu cuenta en PokTaPok y conecta tu wallet de criptomonedas.</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-green-600 flex items-center justify-center mx-auto mb-4">
                <i className="ri-football-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">2. Reserva</h3>
              <p className="text-gray-600 text-sm">Busca y reserva tu cancha favorita como siempre lo haces.</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-green-600 flex items-center justify-center mx-auto mb-4">
                <i className="ri-coins-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">3. Gana</h3>
              <p className="text-gray-600 text-sm">Recibe PokTaToken automaticamente en tu wallet por cada reserva.</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-green-600 flex items-center justify-center mx-auto mb-4">
                <i className="ri-gift-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">4. Canjea</h3>
              <p className="text-gray-600 text-sm">Usa tus tokens para descuentos, acceso VIP o canchas gratuitas.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Asistente 24/7 Banner */}
      <section className="py-12 bg-gray-800 text-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-green-600 flex items-center justify-center shrink-0">
                <i className="ri-customer-service-2-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold">Asistente de Atencion 24/7</h3>
                <p className="text-gray-300 text-sm">
                  Nuestro asistente de IA esta disponible todo el dia para ayudarte con tus reservas, 
                  responder preguntas sobre PokTaToken y guiarte en el proceso.
                </p>
              </div>
            </div>
            <Button
              className="bg-green-600 hover:bg-green-700 shrink-0"
              onClick={() => {
                const btn = document.querySelector('#vapi-widget-floating-button');
                if (btn) (btn as HTMLElement).click();
              }}
            >
              <i className="ri-chat-voice-line mr-2"></i>
              Hablar con Asistente
            </Button>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-green-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Unete a la revolucion PokTaToken
          </h2>
          <p className="text-green-100 text-lg max-w-2xl mx-auto mb-10">
            Se de los primeros en Mexico en usar una criptomoneda diseñada 
            especificamente para el mundo del futbol.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              className="bg-white text-green-800 hover:bg-gray-100"
              onClick={() => navigate('/registro')}
            >
              <i className="ri-user-add-line mr-2"></i>
              Crear Cuenta
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-white text-white hover:bg-white hover:text-green-800"
              onClick={() => navigate('/roadmap')}
            >
              <i className="ri-map-line mr-2"></i>
              Ver Roadmap
            </Button>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Preguntas Frecuentes
            </h2>
            <p className="text-gray-600 text-lg">
              Todo lo que necesitas saber sobre PokTaToken
            </p>
          </div>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-gray-800 pr-4">{faq.question}</span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-gray-500 transition-transform shrink-0 ${
                      openFaq === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {openFaq === index && (
                  <div className="px-6 pb-6">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}